import { render, staticRenderFns } from "./suApplayUditList.vue?vue&type=template&id=112e5158&scoped=true"
import script from "./suApplayUditList.vue?vue&type=script&lang=js"
export * from "./suApplayUditList.vue?vue&type=script&lang=js"
import style0 from "./suApplayUditList.vue?vue&type=style&index=0&id=112e5158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112e5158",
  null
  
)

export default component.exports